/**
 * File navigation.js.
 *
 * Handles toggling the navigation menu for small screens.
 * navigation support for dropdown menus.
 * 1.0.0
 */
(function nav($, utils) {
    const nav = {
        $dropDown:       $('#main-menu li.dropdown'),
        $dropDownToggle: $('#main-menu a.dropdown-toggle'),
        // $dropDownItems:  $('#main-menu a.dropdown-item'),
        $mainMenu:       $('#main-menu'),
        $links:          $('#menu-primary-menu ul a'),
        $shareBtns:      $('.nav-share-btn .menu-item'),

        /**
         * Change the behavior of the drop down from click to hover.
         * @param {Event} e Event object [mouseover mouseleave].
         */
        dropDownMouse(e) {
            utils.toggleDropdown('.dropdown', 'hide');
            if (e.type === 'mouseover')
                utils.toggleDropdown(this, 'show');
        },

        anchorForceLocation() {
            const target = this.getAttribute('target') || this.getAttribute('data-target');
            const href = this.getAttribute('href') || this.getAttribute('data-href');
            target ? window.open(href, target) : window.location.href = href;
        },

        /**
        * Toggles `focus` class to allow submenu access on mobile.
        * Prevent the main dropdown link from navigating away on mobile.
        */
        dropDownToggleMobileClick(e) {
            const isOpened = this.parentNode.classList.contains('show');
            const action = isOpened ? 'hide' : 'show';
            utils.toggleDropdown('.dropdown', 'hide'); // close all dropDowns.
            utils.toggleDropdown(this.parentNode, action);
            e.preventDefault();
            return false;
        },

        /**
         * Each time a menu link is focused or blurred, toggle focus.
         * @param {Event} e Event object [focus blur].
         */
        linksFocus(e) {
            nav.$links.removeClass('focus');
            if (e.type === 'focus')
                this.classList.add('focus');
        },

        setActiveLink() {
            const path = window.location.pathname;
            const hash = window.location.hash;
            nav.$mainMenu.find('.current-menu-parent .active').removeClass('active force-active');
            nav.$mainMenu.find('a').each((key, el) => {
                if (el.href.includes(path) && path !== '/') {
                    if (!hash) {
                        if (!el.href.includes('#'))
                            $(el).closest('li').addClass('active force-active');
                        return;
                    }
                    if (el.href.includes(hash))
                        $(el).closest('li').addClass('active force-active');
                }
            });
        },

        dropDownToggleBehavior() {
            if (utils.getBreakpoint('xs sm md')) {
                // Open menus on mobile instead of navigating away.
                nav.$dropDownToggle.on('touchstart', nav.dropDownToggleMobileClick).off('mousedown', nav.anchorForceLocation);
                nav.$dropDown.off('mouseover mouseleave', nav.dropDownMouse);
            } else {
                // Allow clicking on desktop.
                nav.$dropDownToggle.on('mousedown', nav.anchorForceLocation).off('touchstart', nav.dropDownToggleMobileClick);
                nav.$dropDown.on('mouseover mouseleave', nav.dropDownMouse);
            }
        },

        onWindowResize() {
            nav.$mainMenu.collapse('hide');
            nav.dropDownToggleBehavior();
        },

        init() {
            nav.setActiveLink();
            nav.dropDownToggleBehavior();

            // Force links with data-href to navigate (mostly dropdown-items)
            $('[data-href]').on('click', nav.anchorForceLocation);

            // Lock / Unlock the body when the navigation opens and closes.
            nav.$mainMenu.on('show.bs.collapse', utils.lockBody);
            nav.$mainMenu.on('hide.bs.collapse', utils.unlockBody);

            nav.$links.on('focus blur', nav.linksFocus);
            utils.globals.$window.on('resize', nav.onWindowResize);
            utils.globals.$window.on('hashchange', nav.setActiveLink);
        },
    };

    // document ready
    $(nav.init);
}(jQuery, window.utilities));
